import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adminComponent from './admin.component';
import adminListComponent from './admin-list.component';
import adminDetailComponent from './admin-detail.component';
import adminService from './admin.service';
import adminDetailService from './admin-detail.service';

let adminModule = angular.module('admin', [
  uiRouter
])

.service('Admin', adminService)
.service('AdminDetail', adminDetailService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/admin');

  $stateProvider
    .state('admin', {
      component: 'admin'
    })
    .state('admin.list', {
      url: '/admin',
      component: 'adminList'
    })
    .state('admin.create', {
      url: '/admin/new',
      component: 'adminDetail',
      params: {
      	id: ""
      }
    })
    .state('admin.edit', {
      url: '/admin/:id/edit',
      component: 'adminDetail',
      params: {
        id: ""
      }
    });
})

.component('admin', adminComponent)
.component('adminList', adminListComponent)
.component('adminDetail', adminDetailComponent)

.name;

export default adminModule;



// WEBPACK FOOTER //
// ./client/app/components/admin/admin.js